import { FIN_BAN_MOVEMENTS_ITEM } from './fin-ban-movements.js'
import { FIN_BAN_BANKS_ITEM } from './fin-ban-banks.js'
import { FIN_BAN_ACCOUNTS_ITEM } from './fin-ban-accounts.js'
import { FIN_BAN_RECONCILIATION_ITEM } from './fin-ban-reconciliation.js'
import { FIN_BAN_LOANS_ITEM } from './fin-ban-loans.js'

/** @type {import('../help-index.js').HelpScreen} */
export const FIN_BAN_HELP = {
  screenId: 'fin-ban',
  label: 'Bancos',
  navPath: 'Finanzas → Bancos',
  keywords: [
    'banco', 'bancos', 'cuenta bancaria', 'movimiento bancario', 'conciliación',
    'extracto', 'transferencia', 'préstamo', 'prestamo', 'cuota',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'En Bancos administrás entidades bancarias, cuentas, movimientos, conciliación con extracto y préstamos. Orden recomendado: primero «Bancos», luego «Cuentas bancarias», y después Movimientos o Conciliación. Expandí cada tema para ver los pasos.',
  sidebarItems: [
    FIN_BAN_MOVEMENTS_ITEM,
    FIN_BAN_BANKS_ITEM,
    FIN_BAN_ACCOUNTS_ITEM,
    FIN_BAN_RECONCILIATION_ITEM,
    FIN_BAN_LOANS_ITEM,
  ],
}
